import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'auto-editor-ui-qn-status-badge',
  templateUrl: './ui-qn-status-badge.component.html',
  styleUrl: './ui-qn-status-badge.component.scss',
  standalone: false
})
export class UiQnStatusBadgeComponent {
  constructor(private translateService: TranslateService) {}
  @Input({ required: true }) status: string;
}
